import { memo, useCallback, useMemo, useState } from "react";
import { useDrag } from "react-dnd";
import { Typography, makeStyles } from "@material-ui/core";


const style = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "start",
};
const useStyles = makeStyles(theme => ({
  iconStyle: {
    marginRight: 10,
    color: "#fff",
    backgroundColor: "#0057B2",
    borderRadius: 4,
  },
}));
export const ComponentDragBox = memo(function ComponentDragBox({
  component,
  text,
  icon,
  children,
}) {
  const classes = useStyles();
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: component,
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [component, text]
  );

  const containerStyle = useMemo(
    () => ({
      ...style,
      opacity: isDragging ? 0.4 : 1,
      cursor: isDragging ? "grabbing" : "grab",
    }),
    [isDragging]
  );
  return (
    <div ref={drag} style={containerStyle} role="ComponentDragBox">
      <Typography variant="h5" style={{ paddingTop: 3 }}>
        {text}
      </Typography>
    </div>
  );
});
